module.exports = {
	global: {
		viewType: undefined,
		homepageMediaType: "any",
		geolocation: {
			accuracy: null,
			latitude: null,
			longitude: null,
			timestamp: null,
			error: null,
			initialData: {
				loading: false,
				loaded: false,
				error: false,
				data: {
					city: [],
					region: [],
					country: [],
				},
			},
		},
		firebaseId: null,
		hashUser: null,
		userCountryFromIp: null,

		layoutVersion: "old",
		// User globalne dane zapisywane w lokal storage o aktualnie zalogowanym userze
		user: {
			loading: false,
			loaded: false,
			success: false,
			error: false,
			id: null,
			acceptedFields: {
				city: false,
				description: false,
				name: false,
				nameCouple: false,
			},
			awaitAccept: false,
			activityToken: null,
			useDataHeader: null,
			activityUrl: null,
			allowLinks: false,
			frozen: false,
			avatar: "",
			avatarMedia: {
				file: undefined,
				type: undefined,
				contentId: undefined,
				width: undefined,
				height: undefined,
			},
			login: "",
			status_vip: 0,
			online: 0,
			profileStatus: 0,
			privateData: false,
			city: null,
			region: null,
			country: null,
			searchSex: [],
			searchAge: [],
			searchFor: [],
			sex: null,
			sound_enable: false,
			urlSearch: "",
			relationship: null,
			languages: [],
			cityName: "",
			regionName: "",
			email: "",
			kids: 0,
			partners: {
				birthday: [],
				sex: [],
				name: [],
				height: [180, 180],
				figure: [],
				zodiak: [],
				hair: [],
				alko: [],
				smoke: [],
				education: [],
			},
			created: null,
			preferences: [],
			interests: [],
			description: {
				parsed: [],
				plain: "",
			},
			post_left: {
				date: null,
				limit: 0,
				max: 0,
			},
			vip_left: {
				date: null,
				time: null,
			},
			set_user: {
				loading: false,
				success: false,
			},

			complete: {},

			suspension: {
				duration: 0,
				to: -1,
				code: -1,
			},
		},
		statisticsSelf: {
			loading: false,
			loaded: false,
			success: false,
			error: false,
			lastUpdate: false,
			likes: 0,
			comments: 0,
			invities: 0,
			friends: 0,
			visitors: 0,
			following: 0,
			messages: 0,
			notifications: 0,
			userStatsHash: "",
		},
		siteStatsHash: "",
		fingerprint: null,
		pwa: {
			status: {
				isInstallAllowed: false,
				isInstallWatingConfirm: false,
				isInstalling: false,
				isInstallCancelled: false,
				isInstallSuccess: false,
				isInstallFailed: false,
			},
			event: null,
		},
		savedPositionsScrollY: [],
	},
	auth: {
		login: {
			loading: false,
			loaded: false,
			error: false,
			errorMessage: null,
			errorCode: null,
		},
		register: {
			registerForm: {
				terms: false,
				registrationId: null,
				gender: {
					coupleCase: false,
					gender: null,
				},
				genderCoupleCase: {
					partner1: null,
					partner2: null,
				},
				age: {
					day: null,
					month: null,
					year: null,
					isSelected: false,
				},
				ageCoupleCase: {
					partner1: { day: null, month: null, year: null },
					partner2: { day: null, month: null, year: null },
					isSelectedPartner1: false,
					isSelectedPartner2: false,
				},
				login: {
					login: "",
					errorFrontend: false,
					loginAvailable: false,
					loadingApi: false,
					successApi: false,
					errorApi: false,
					errorApiMessage: null,
				},
				email: {
					email: null,
					errorFrontend: false,
					emailAvailable: false,
					loadingApi: false,
					successApi: false,
					errorApi: false,
					errorApiMessage: null,
				},
				password: {
					password: null,
					errorFrontend: false,
				},
				location: {
					city: null,
					region: null,
					country: null,
				},
			},
			loading: false,
			loaded: false,
			error: false,
		},
		recover: { loading: false, loaded: false, error: false },
		fakeUserData: {
			avatar: null,
			city: null,
			region: null,
			country: null,
			login: null,
			sex: null,
			userData: {
				age: null,
				birthday: null,
			},
		},
		sentSmsCodeTime: null,
		blockTime: null,
		countryCode: null,
		phoneNubmer: null,
		isoCountryCode: null,
		token: null,
		tempToken: null,
		jwt: null,
		isAuthFromServer: false,
	},
	user: {
		galleries: {
			albums_list: {
				loading: false,
				loaded: false,
				data: [],
			},
			current_album: {
				loading: false,
				loaded: false,
			},
		},
		images: {
			albums_list: {
				loading: false,
				loaded: false,
				data: [],
			},
			current_album: {
				loading: false,
				loaded: false,
			},
		},
		videos: {
			albums_list: {
				loading: false,
				loaded: false,
				data: [],
			},
			current_album: {
				loading: false,
				loaded: false,
			},
		},
		suspension: {
			duration: 0,
			to: -1,
			code: -1,
		},
	},

	mainPages: {},
};
